<div class="ruler">
  <ng-container *ngIf="(ruler$ | async) === '24'">
    <div></div>
    <div><span>2</span></div>
    <div><span>4</span></div>
    <div><span>6</span></div>
    <div><span>8</span></div>
    <div><span>10</span></div>
    <div><span>12</span></div>
    <div><span>14</span></div>
    <div><span>16</span></div>
    <div><span>18</span></div>
    <div><span>20</span></div>
    <div><span>22</span></div>
    <div></div>
  </ng-container>

  <ng-container *ngIf="(ruler$ | async) === '12'">
    <div></div>
    <div><span>2 <span>AM</span></span></div>
    <div><span>4 <span>AM</span></span></div>
    <div><span>6 <span>AM</span></span></div>
    <div><span>8 <span>AM</span></span></div>
    <div><span>10 <span>AM</span></span></div>
    <div><span>12 <span>PM</span></span></div>
    <div><span>2 <span>PM</span></span></div>
    <div><span>4 <span>PM</span></span></div>
    <div><span>6 <span>PM</span></span></div>
    <div><span>8 <span>PM</span></span></div>
    <div><span>10 <span>PM</span></span></div>
    <div></div>
  </ng-container>

  <ng-container *ngIf="(ruler$ | async) === '6'">
    <div></div>
    <div><span>2 <span>AM</span></span></div>
    <div></div>
    <div><span>6 <span>AM</span></span></div>
    <div></div>
    <div><span>10 <span>AM</span></span></div>
    <div></div>
    <div><span>2 <span>PM</span></span></div>
    <div></div>
    <div><span>6 <span>PM</span></span></div>
    <div></div>
    <div><span>10 <span>PM</span></span></div>
    <div></div>
  </ng-container>
</div>

<div class="ruler-half">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>

<div class="tubes">
  <div *ngFor="let item of (items$ | async); index as i; trackBy: trackBy" class="tube computer"
    [style.left.%]="item.left" [style.width.%]="item.width" (click)="clickLog.emit(item)">
  </div>
</div>
